<template>
  <v-dialog
    v-model="showUserLoginDialog"
    ref="dialog"
    hide-overlay
    max-width="500px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
  >
    <v-card>
      <form>
        <v-card-title class="primary white--text">
          <h3 class="headline mb-0">{{ $t('texts.login') }}</h3>
          <v-spacer/>
          <v-btn text small fab @click="showUserLoginDialog = false">
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-text-field
              v-model="login.email"
              :label="$t('texts.email')"
              required
              v-validate.disable="'required|email'"
              data-vv-name="email"
              :data-vv-as="$t('texts.email')"
              :error-messages="errors.collect('email')"
            />
            <v-text-field
              v-model="login.password"
              name="loginPassword"
              :label="$t('texts.insertPassword')"
              :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
              @click:append="() => (hidePassword = !hidePassword)"
              :type="hidePassword ? 'password' : 'text'"
              required
              v-validate="'required'"
              data-vv-name="insertPassword"
              :data-vv-as="$t('texts.insertPassword')"
              :error-messages="errors.collect('insertPassword')"
              @keyup.enter.native="handleLoginFormSubmit()"
              autocomplete="current-password"
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn color="secondary" small text @click="showUserPasswordResetDialog()">
            {{ $t('texts.forgotPassword') }}
          </v-btn>
          <v-spacer/>
          <v-btn
            color="primary"
            @click="handleLoginFormSubmit()"
            :disabled="buttonLoading"
            :loading="buttonLoading"
          >
            {{ $t('texts.login') }}
            <v-icon right dark>check_circle</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider/>
        <v-card-actions class="justify-center text-center">
          <div>
            {{ $t('texts.noAccountYet') }}
            <v-btn
              small text color="primary"
              @click="showUserRegistrationDialog()"
            >
              {{ $t('texts.registerNow') }}
            </v-btn>
          </div>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'UserLoginDialog',
  data() {
    return {
      showUserLoginDialog: false,
      buttonLoading: false,
      showSuccess: false,
      login: {
        username: '',
        password: '',
      },
      hidePassword: true,
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  mounted() {
    this.$eventBus.$on('show-user-login-dialog', () => {
      this.closeUserRegistrationDialog();
      this.$validator.reset();
      this.showUserLoginDialog = true;
    });
    this.$eventBus.$on('close-user-login-dialog', () => {
      this.showUserLoginDialog = false;
    });
  },
  methods: {
    ...mapMessageActions([
      'showMessage',
    ]),
    handleLoginFormSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.buttonLoading = true;
          const postData = {
            email: this.login.email,
            password: this.login.password,
          };
          this.$auth.login({
            data: postData,
            rememberMe: true,
            fetchUser: true,
            success() {
              this.buttonLoading = false;
              this.showUserLoginDialog = false;
              this.$store.dispatch('user/setUserObject', this.$auth.user());
              this.$store.dispatch('user/setInRegistrationProcess', false);
              // this.$router.push({path: '/home'})
            },
            error(response) {
              this.buttonLoading = false;
              this.showMessage({
                text: response.response.data.error,
                color: 'error',
              });
            },
          });
        }
      });
    },
    showUserPasswordResetDialog() {
      this.showUserLoginDialog = false;
      this.$eventBus.$emit('show-user-password-reset-dialog');
    },
    showUserRegistrationDialog() {
      this.$eventBus.$emit('show-user-registration-dialog');
    },
    closeUserRegistrationDialog() {
      this.$eventBus.$emit('close-user-registration-dialog');
    },
  },
};
</script>
